import { render, staticRenderFns } from "./UserStakingStatsFilters.vue?vue&type=template&id=03467076&"
import script from "./UserStakingStatsFilters.vue?vue&type=script&lang=js&"
export * from "./UserStakingStatsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports